import { render, staticRenderFns } from "./RecordBase.vue?vue&type=template&id=dcfa6692&"
import script from "./RecordBase.vue?vue&type=script&lang=js&"
export * from "./RecordBase.vue?vue&type=script&lang=js&"
import style0 from "./RecordBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports